export default __webpack_public_path__ + "media/images/folder-icon-for-email@1x-010073d1.png";